/* Niclas + ChatGPT | 2026-10-02 | AVOLT global chat */
function onTidioChatApiReady() {
  // Flytta knappen ner 34px
  tidioChatApi.adjustStyles('#tidio { bottom: -34px !important; right: -2px !important; }');
  
  // Mobile version
  tidioChatApi.adjustStyles(
    '@media only screen and (max-width: 980px) { #tidio { bottom: -2px !important; right: 6px !important; } }',
  );
}

if (window.tidioChatApi) {
  window.tidioChatApi.on('ready', onTidioChatApiReady);
} else {
  document.addEventListener('tidioChat-ready', onTidioChatApiReady);
}

/* AVOLT | Niclas + Codex | 2026-10-14 | Footer access to Avada; see deliveries/2026-10-14-accessibility-footer/README.md. */
(() => {
  const linkSelector = 'footer a[href$="#accessibility-settings"]';
  const widgetSelector = '#Sea-Accessibility__ButtonWidget';
  const loaderSelector = '#Sea-Accessibility__LoaderButton';
  let lastTrigger;
  let wasOpen = false;
  let pendingOpen = false;

  const syncExpanded = () => {
    const open = document.querySelector(widgetSelector)?.getAttribute('aria-expanded') === 'true';
    document.querySelectorAll(linkSelector).forEach(link => link.setAttribute('aria-expanded', String(open)));
    if (wasOpen && !open && lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
    wasOpen = open;
  };

  const openMenu = (event, link) => {
    const widget = document.querySelector(widgetSelector) || document.querySelector(loaderSelector);
    if (!widget || !link) return;
    event.preventDefault();
    lastTrigger = link;
    pendingOpen = widget.matches(loaderSelector);
    queueMicrotask(() => widget.click());
  };

  const initialise = () => {
    const widget = document.querySelector(widgetSelector);
    const links = document.querySelectorAll(linkSelector);
    if (!widget || !links.length) return false;
    links.forEach(link => {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
    });
    new MutationObserver(syncExpanded).observe(widget, { attributes: true, attributeFilter: ['aria-expanded'] });
    syncExpanded();
    if (pendingOpen) requestAnimationFrame(() => {
      pendingOpen = false;
      if (widget.getAttribute('aria-expanded') !== 'true') widget.click();
    });
    document.documentElement.setAttribute('data-avolt-accessibility-ready', 'true');
    return true;
  };

  const start = () => {
    const links = document.querySelectorAll(linkSelector);
    if (!links.length) return;
    links.forEach(link => {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('click', event => openMenu(event, event.target.closest?.(linkSelector)));
    document.addEventListener('keydown', event => {
      if (event.key === ' ') openMenu(event, event.target.closest?.(linkSelector));
    });
    if (initialise()) return;
    const observer = new MutationObserver(() => { if (initialise()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
